import Popup from 'reactjs-popup';
import dayjs from 'dayjs';
import { Link } from 'react-router-dom';
import updateLocale from 'dayjs/plugin/updateLocale';
import { PopUpConfirmationProps } from './Interfaces';
import { FaRegCheckCircle } from "react-icons/fa";
import 'dayjs/locale/es';
import '../styles/popUpConfirmation.css';
import calendarIcon from '../assets/images/Calendarui_Verde.png';
import clockIcon from '../assets/images/Reloj_Verde.png';
import estetoscopioIcon from '../assets/images/Estetoscopio_Blanco.png'
import sucursalIcon from '../assets/images/Sucursal_Blanco.png'
import ubicacionIcon from '../assets/images/Ubicacion_Blanco.png'
import { TfiWrite } from "react-icons/tfi";
import axios from 'axios';
import { useEffect, useState } from 'react';

dayjs.extend(updateLocale);
dayjs.updateLocale('en', {
  weekStart: 1,
  weekdays: [
    'Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado',
  ],
});

const baseURL = process.env.REACT_APP_BASEURL;
const authorization = process.env.REACT_APP_AUTHORIZATION;
const nestApiURL = process.env.REACT_APP_NEST_API_URL;
const apiKey = process.env.REACT_APP_API_KEY;

const PopUpConfirmation = ({
  isOpen,
  closeModal,
  hourSelected,
  dataLabels,
  dataClient,
}: PopUpConfirmationProps) => {
  // Inicializar con valores vacíos para forzar que se actualicen desde el API
  const [facilityStreet, setFacilityStreet] = useState<string>('');
  const [facilityState, setFacilityState] = useState<string>('');

  // Actualizar SOLO la dirección del facility cuando se selecciona una hora
  useEffect(() => {
    if (isOpen && hourSelected?.facility) {
      // El hourSelected.facility contiene el id_facility del JSON de respuesta de la hora
      const facilityId = hourSelected.facility;
      
      if (process.env.NODE_ENV === 'development') {
        console.log('🔍 Buscando facility para id_facility:', facilityId);
        console.log('📍 Dirección actual en dataLabels:', dataLabels.facility.street);
      }
      
      // === LÓGICA ANTIGUA COMENTADA ===
      /*
      axios.post(`${baseURL}/alma/external/pp/v1/facility`, '', {
        headers: {
          Authorization: authorization,
        },
      }).then((response: any) => { ... })
      */

      // === NUEVA LÓGICA NESTJS ===
      axios.get(`${nestApiURL}/facilities`, {
        headers: {
          'API_KEY': apiKey,
        }
      }).then((response: any) => {
        // Validamos la estructura de NestJS
        if (response?.data?.status === 'success' && Array.isArray(response?.data?.data)) {
          // Buscar el facility que coincida con el id_facility de la hora seleccionada
          const facility = response.data.data.find((item: any) => {
            const itemId = String(item.id);
            const searchId = String(facilityId);
            return itemId === searchId;
          });
          
          if (facility) {
            if (process.env.NODE_ENV === 'development') {
              console.log('✅ Facility encontrado:', facility);
              console.log('📍 Nueva dirección del facility:', facility.street);
            }
            // Actualizar SOLO la dirección (street) y state con la información del JSON de respuesta
            const newStreet = facility.street || '';
            const newState = facility.state || '';
            
            // Actualizar estados locales (esto forzará el re-render)
            setFacilityStreet(newStreet);
            setFacilityState(newState);
            
            // También actualizar dataLabels para que se propague a otras partes
            dataLabels.facility.street = newStreet;
            dataLabels.facility.state = newState;
            
            if (process.env.NODE_ENV === 'development') {
              console.log('✅ Estados actualizados - facilityStreet:', newStreet, 'facilityState:', newState);
            }
          } else {
            // Si no se encuentra, usar los valores de dataLabels como fallback
            const fallbackStreet = dataLabels.facility.street || '';
            const fallbackState = dataLabels.facility.state || '';
            setFacilityStreet(fallbackStreet);
            setFacilityState(fallbackState);
            if (process.env.NODE_ENV === 'development') {
              console.warn('❌ Facility no encontrado para id:', facilityId);
              console.log('Facilities disponibles:', response.data.data.map((f: any) => ({ id: f.id, name: f.name })));
            }
          }
        } else {
           // En caso de que la API retorne éxito pero con un formato inesperado
           setFacilityStreet(dataLabels.facility.street || '');
           setFacilityState(dataLabels.facility.state || '');
        }
      }).catch((err) => {
        console.error('Error al buscar facility:', err);
        // En caso de error, usar los valores de dataLabels como fallback
        setFacilityStreet(dataLabels.facility.street || '');
        setFacilityState(dataLabels.facility.state || '');
      });
    } else if (!isOpen) {
      // Resetear cuando se cierra el modal
      setFacilityStreet('');
      setFacilityState('');
    }
  }, [isOpen, hourSelected?.facility]);

  // Log para verificar el estado actual en cada render
  useEffect(() => {
    if (process.env.NODE_ENV === 'development' && isOpen) {
      console.log('🔄 [Render] Estado actual - facilityStreet:', facilityStreet, 'facilityState:', facilityState);
    }
  }, [facilityStreet, facilityState, isOpen]);

  const handleOpen = () => {
    // Cuando se abre el modal, desplazar el scroll del contenido al principio
    setTimeout(() => {
      const modalId = document.getElementsByClassName('popup-content');
      if (modalId && modalId[0]) {
        modalId[0].scrollTop = 0;
      }
    }, 0);
  };

return (
  <Popup
    modal
    lockScroll={false}
    closeOnDocumentClick={false}
    position="center center"
    open={isOpen}
    onClose={closeModal}
    onOpen={handleOpen}
  >
    <div className="modal">
      <div className="titleModalContent">
        <FaRegCheckCircle size={50} color='white' style={{ marginBottom: '1%', marginTop: '1%' }} />
        <p className="subTitleText">
          {' '}
          Confirmación de datos
        </p>
      </div>
      <div className="content">
        <div className="body">
          <div className="titleBodyPopUp">
            <div style={{ display: 'flex', flexDirection: 'row', width: '100%', alignItems: 'center', height: '50%', flex: 5 }}>
              <div style={{ width: '16%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <img src={calendarIcon} alt='calendar' style={{ width: '50%', height: '50%' }} />
              </div>
              <div className='titleTextLeft'>
                {dayjs(hourSelected.reservationHour).format('dddd')}
                {' '}
                {dayjs(hourSelected.reservationHour).format('D')}
                {' '}
                de
                {' '}
                {dayjs(hourSelected.reservationHour).locale('es').format('MMMM')}
                {' '}
              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'row', width: '100%', alignItems: 'center', height: '50%', flex: 5 }}>
              <div style={{ width: '16%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <img src={clockIcon} alt='calendar' style={{ width: '45%', height: '45%' }} />
              </div>
              <div className='titleTextRight'>
                {' '}
                {hourSelected?.reservationHour?.substring(11, 16)}
                {' '}
                hrs
              </div>
            </div>
          </div>
          <p className='subTitleText'>
            Datos de atención
          </p>
          <div className="rowInfoConfirmation">
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '11%', height: '70%', marginTop: 0, marginBottom: 0 }}>
              <img src={estetoscopioIcon} alt='calendar' style={{ width: '100%', height: '100%' }} />
            </div>
            <div style={{ flexDirection: 'column', width: '100%' }}>
              <div className='dataLabelTitle'>
                Especialidad
              </div>
              <div style={{marginTop: 0, marginBottom: 0, fontWeight: 'bold', textAlign: 'justify'}}>
                {dataLabels.specialty}
              </div>
            </div>
          </div>
          <div style={{ borderTop: "1px solid white", margin: "0px 0" }} />
          <div className="rowInfoConfirmation">
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '11%', height: '70%', marginTop: 0, marginBottom: 0 }}>
              <img src={estetoscopioIcon} alt='calendar' style={{ width: '100%', height: '100%' }} />
            </div>
            <div style={{ flexDirection: 'column', width: '100%' }}>
              <div className='dataLabelTitle'>
                Prestación
              </div>
              <div style={{marginTop: 0, marginBottom: 0, fontWeight: 'bold', textAlign: 'justify'}}>
                {dataLabels.category.toLowerCase().replace(/\b\w/g, l => l.toUpperCase())}
              </div>
            </div>
          </div>
          <div style={{ borderTop: "1px solid white", margin: "0px 0" }} />
          <div className="rowInfoConfirmation">
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '11%', height: '85%', marginBottom: 0, marginTop: 6 }}>
              <img src={sucursalIcon} alt='calendar' style={{ width: '100%', height: '100%' }} />
            </div>
            <div style={{ flexDirection: 'column', width: '100%' }}>
              <div className='dataLabelTitle'>
                Sucursal
              </div>
              <div style={{marginTop: 0, marginBottom: 0, fontWeight: 'bold'}}>
                {dataLabels.facility.name}
              </div>
            </div>
          </div>
          <div style={{ borderTop: "1px solid white", margin: "0px 0" }} />
          <div className="rowInfoConfirmation">
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '11%', height: '65%' }}>
              <img src={ubicacionIcon} alt='calendar' style={{ width: '100%', height: '100%' }} />
            </div>
            <div style={{ flexDirection: 'column', width: '100%' }}>
              <div className='dataLabelTitle'>
                Dirección
              </div>
              <div style={{marginTop: 0, marginBottom: 0, fontWeight: 'bold', textAlign: 'justify'}}>
                {(() => {
                  const displayStreet = facilityStreet || dataLabels.facility.street || '';
                  const displayState = facilityState || dataLabels.facility.state || '';
                  
                  if (process.env.NODE_ENV === 'development') {
                    console.log('🎨 [Render Dirección] facilityStreet:', facilityStreet, '| dataLabels.street:', dataLabels.facility.street, '| displayStreet:', displayStreet);
                  }
                  
                  return (
                    <>
                      {displayStreet}
                      {displayState && `, ${displayState}`}
                    </>
                  );
                })()}
              </div>
            </div>
          </div>
          <div style={{ borderTop: "1px solid white", margin: "0px 0" }} />
          <div className="rowInfoConfirmation">
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '11%', height: '70%', marginTop: 0, marginBottom: 0 }}>
              <TfiWrite size={30} color='white' />
            </div>
            <div style={{ flexDirection: 'column', width: '100%' }}>
              <div className='dataLabelTitle'>
                Preparación
              </div>
              <div style={{marginTop: 0, marginBottom: 0, fontWeight: 'bold', textAlign: 'justify', fontSize: 'calc(10px + .25vw)'}}>
                {hourSelected.preparacion ? String(hourSelected.preparacion).split('\n').map((line, index) => {
                  const linkMatch = line.match(/\[([^\]]+)\]\(([^)]+)\)/);
                  if (linkMatch) {
                    const [, linkText, url] = linkMatch;
                    return (
                      <div key={index}>
                        {line.replace(/\[([^\]]+)\]\(([^)]+)\)/, '')}
                        <a 
                          href={url} 
                          target="_blank" 
                          rel="noopener noreferrer"
                          style={{ 
                            color: '#007bff', 
                            textDecoration: 'underline',
                            cursor: 'pointer'
                          }}
                        >
                          {linkText}
                        </a>
                      </div>
                    );
                  }
                  return <div key={index}>{line}</div>;
                }) : ''}
              </div>
            </div>
          </div>
        </div>
        <div className="buttom">
          <div style={{ width: '40%' }}>
            <button
              type="button"
              className="confirmButtonCancel"
              onClick={() => {
                closeModal();
              }}
              data-event="click_btn_cancelar_popup"
              data-value="cancelar"
            >
              Cancelar
            </button>
          </div>
          <Link
            style={{ width: '40%' }}
            to="/hour-reservation"
            state={{ dataHour: hourSelected, dataClient, dataLabels }}
            data-event="click_btn_confirmar_datos"
            data-value="confirmar"
          >
            <button type="button" className="confirmButtonReserva">
              Siguiente
            </button>
          </Link>
        </div>
      </div>
    </div>
  </Popup>
)};

export default PopUpConfirmation;